// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N3Hu4bmCi6kjag8Nnxrh {
  height: auto !important;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/table-columns/article-actions/component/styles.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,qBAAA;AACF","sourcesContent":[".menu_item {\n  height: auto !important;\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu_item": `N3Hu4bmCi6kjag8Nnxrh`
};
export default ___CSS_LOADER_EXPORT___;
